import { createAction } from 'typesafe-actions';

import { EPublishPeriod } from 'shared/types/filters/advanced/publishPeriods';

export const changePublishPeriodAction = createAction('filters/publishPeriodChanged')<EPublishPeriod>();
